import { userSlice } from "./reducer";

export const {
  login,
  loginAs,
  logout,
  setLang,
  setToken,
  setRoles,
  setLocation,
} = userSlice.actions;
